import React, { useState, useEffect } from 'react';
import { TextField, } from '@mui/material';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { AppContext } from '../../services/AppContext';


type CountryPickerProps = {
    phoneText: string;
    onChange: (phone: string, phoneError: boolean) => void
}

const CountryCodePicker: React.FC<CountryPickerProps> = ({ phoneText, onChange }: CountryPickerProps) => {

    const [selectedCode, setSelectedCode] = useState<string>('91');
    const [phone, setPhone] = useState<string>(phoneText);
    const [error, setError] = useState<boolean>(false);


    useEffect(() => {
        AppContext.phone = `(+${selectedCode})${phone}`
    }, [selectedCode, phone,]);

    useEffect(() => {
        const isIndian = selectedCode === '91';
        const indianMobileRegex = /^[6-9]\d{9}$/;

        if (isIndian && !indianMobileRegex.test(phone) && phone !== "") {
            setError(true);
        } else {
            setError(false);
        }
    }, [selectedCode]);

    const handlePhoneChange = (value: string) => {
        //const code = value.substring(1, value.length); // Extract code from value
        setSelectedCode(value);
        // console.log("Selected Code: " + value); // Log
    };

    const handlePhoneInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newPhone = event.target.value;
        setPhone(newPhone);
        phoneText = newPhone
        const isIndian = selectedCode === '91';
        const indianMobileRegex = /^[6-9]\d{9}$/;

        const newError = isIndian && !indianMobileRegex.test(newPhone);
        setError(newError);
        onChange(newPhone, newError);

    };

    return (
        <>
            <div className="row g-1">
                <div className="col-4 col-sm-4 col-md-4">
                    <PhoneInput
                        country={selectedCode.toLowerCase()}
                        value={selectedCode}
                        countryCodeEditable={false}
                        enableSearch={false}
                        onChange={handlePhoneChange}
                        containerStyle={{
                            width: '100%',
                            marginTop: '9px',
                            border: '1px solid #ccc',
                            borderRadius: '2px',
                        }}
                        inputStyle={{
                            width: '100%',
                            height: '54px',
                            textAlign: 'right',
                            paddingLeft: '10px',
                            paddingRight: '5px',
                            fontSize: '16px',
                            borderRadius: '1px',
                            border: 'none',
                        }}
                        buttonStyle={{
                            borderRadius: '2px 0 0 2px',
                            backgroundColor: '#f1f1f1',
                        }}
                        dropdownStyle={{
                            borderRadius: '1px',
                        }}
                        inputProps={{
                            readOnly: true,
                        }}
                    />
                </div>

                <div className="col-8 col-sm-8 col-md-8">
                    <TextField
                        name="phoneNumber"
                        label="Your WhatsApp Number"
                        variant="outlined"
                        value={phoneText}
                        fullWidth
                        onChange={handlePhoneInputChange}
                        error={error}
                        helperText={
                            error ? "Enter a 10-digit valid mobile number." : ''
                        }
                        sx={{ bgcolor: 'white', width: '100%', borderRadius: 1, mt: 1, mb: 0 }}
                    />
                </div>
            </div>

        </>

    );
};

export default CountryCodePicker;
